import { api } from '../../core/api.js';
import { register } from '../../core/events.js';
import { html } from '../../core/html.js';
import { fmtWhen } from '../../core/format.js';
import { reload, update } from '../../app/shell.js';
import { banner, empty, ic, seg, table, tag } from '../../ui/components.js';
import { toast } from '../../ui/toast.js';

export function classState(c) {
  switch (c.state) {
    case 'live': return tag('Live now', 'bad');
    case 'live_soon': return tag('Live soon', 'wn');
    case 'recording': return c.attended === false ? tag('Missed', 'n') : tag('Completed', 'ok');
    case 'cancelled': return tag('Cancelled', 'n');
    default: return tag('Scheduled', 'n');
  }
}

function rowAction(c, area) {
  if (c.state === 'live' || (c.state === 'live_soon' && c.can_join)) return html`<a class="btn sm" href="/${area}/classes/${c.id}">${c.state === 'live' ? 'Join' : 'Open lobby'}</a>`;
  if (c.state === 'recording') {
    return c.recording_id
      ? html`<a class="btn soft sm" href="/${area}/recordings/${c.recording_id}">Watch</a>`
      : html`<a class="btn ghost sm" href="/${area}/classes/${c.id}">Details</a>`;
  }
  if (c.state === 'cancelled') return '';
  return html`<button type="button" class="btn ghost sm" data-act="classes.remind" data-id="${c.id}" data-on="${!c.reminder}">${c.reminder ? 'Reminder on' : 'Remind me'}</button>`;
}

const classes = {
  path: '/student/classes',
  roles: ['student'],
  title: 'Live classes',
  ui: () => ({ scope: 'upcoming' }),
  load: async (ctx) => {
    const [upcoming, past] = await Promise.all([
      api.get('/classes', { signal: ctx.signal, query: { scope: 'upcoming' } }),
      api.get('/classes', { signal: ctx.signal, query: { scope: 'past' } }),
    ]);
    return { upcoming: upcoming.classes, past: past.classes };
  },
  view(d, ui) {
    const list = d[ui.scope];
    const next = d.upcoming.find((c) => c.state === 'live' || c.state === 'live_soon');
    const attended = d.past.filter((c) => c.attended).length;
    return html`${next ? banner(html`<b>${next.course}, class ${next.number}, ${fmtWhen(next.starts_at)}.</b> The room opens a few minutes early.`, 'info', 'play') : ''}
      <div class="row between mt-s mb">${seg([['upcoming', `Upcoming (${d.upcoming.length})`], ['past', 'Past']], ui.scope, 'classes.scope', 'Classes')}</div>
      ${list.length
        ? table(['Course', 'Class', 'When', 'Trainer', 'Status', ''], list.map((c) => [c.course, `#${String(c.number).padStart(2, '0')} ${c.title}`, fmtWhen(c.starts_at), c.trainer, classState(c), rowAction(c, 'student')]))
        : empty('play', ui.scope === 'upcoming' ? 'No upcoming classes' : 'No past classes yet', ui.scope === 'upcoming' ? 'Join a course to see your timetable here.' : 'Classes you have taken appear here.', ui.scope === 'upcoming' ? html`<a class="btn" href="/student/learn">Find a course</a>` : '')}
      ${d.past.length ? html`<p class="note mt-s">${ic('check')} You attended ${attended} of your last ${d.past.length} classes.</p>` : ''}`;
  },
};

register({
  'classes.scope': (el) => update((ui) => { ui.scope = el.dataset.value; }),
  'classes.remind': async (el) => {
    const on = el.dataset.on === 'true';
    await api.put(`/classes/${el.dataset.id}/reminder`, { body: { on } });
    toast(on ? 'Reminder set. We will notify you before class.' : 'Reminder removed', 'bell');
    await reload();
  },
});

export const routes = [classes];
